import React from 'react';
import _ from 'lodash';
import {
  Box,
  Stack,
  Button,
  Card,
  CardContent,
  Typography,
  Chip,
  Fab,
  Tooltip,
  IconButton,
  Checkbox,
  useMediaQuery
} from '@mui/material';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { SmallFormTextField } from '../../../../../components/small-fields/SmallFormTextField';
import { SmallFormDateField } from '../../../../../components/small-fields/SmallFormDateField';
import { formatDate } from '../../../../../services/functions';
import { useManager } from '../../../../../pages/Manager';
import ImageModal from '../../../../employee/generics/components/ImageModal';
import defaultImage from '../default.png';
import { useSelector } from 'react-redux';

export default function EmployeeData({
  formik,
  fileInputRef,
  loading,
  preview,
  isDefaultPhoto
}) {
  const isMobile = useMediaQuery('(max-width:600px)');
  const { managerEmployee: rowData, choices } = useManager();
  const { seasonIdentifier } = useSelector(state => state.app);
  const [open, setOpen] = React.useState(false);
  const [openImage, setOpenImage] = React.useState(false);

  // console.log("chocies,", choices);

  return (
    <Stack height={isMobile ? '70vh' : '100vh'}>
      <Stack direction="row" justifyContent="space-between">
        <SmallFormTextField
          select
          disabled
          label="Typ"
          name="employee_type"
          placeholder="Typ"
          value={formik.values.employee_type}
          onChange={formik.handleChange}
          sx={{ width: isMobile ? '100%' : '40%', mt: 2 }}
          options={choices.employee_type}
        />
      </Stack>
      <Stack sx={{ mt: 2 }} direction={isMobile ? 'column' : 'row'} spacing={2}>
        <Card sx={{ width: '200px', height: '250px' }}>
          <CardContent>
            <img
              src={preview}
              style={{
                objectFit: 'cover',
                width: '150px',
                height: '150px',
                margin: '0 auto',
                border: '2px solid #00AB55',
                borderRadius: '16px',
                cursor: 'zoom-in'
              }}
              onClick={() => setOpenImage(true)}
            ></img>
            <Stack
              style={{ marginTop: '10px' }}
              direction="row"
              justifyContent="space-between"
            >
            </Stack>
          </CardContent>
        </Card>
        <Card sx={{ flex: 1 }}>
          <CardContent>
            <Stack spacing={2}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="left"
                spacing={1}
              >
                <Typography
                  variant="subtitle2"
                  sx={{
                    width: '25%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'pre'
                  }}
                >
                  Imię
                </Typography>
                <SmallFormTextField
                  name="name"
                  disabled
                  placeholder="Imię"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  helperText={formik.errors.name}
                  error={formik.errors.name && formik.touched.name}
                  sx={{ width: '75%' }}
                />
              </Stack>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="left"
                spacing={1}
              >
                <Typography
                  variant="subtitle2"
                  sx={{
                    width: '25%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'pre'
                  }}
                >
                  Nazwisko
                </Typography>
                <SmallFormTextField
                  name="surname"
                  disabled
                  placeholder="Naziwsko"
                  value={formik.values.surname}
                  onChange={formik.handleChange}
                  helperText={formik.errors.surname}
                  error={formik.errors.surname && formik.touched.surname}
                  sx={{ width: '75%' }}
                />
              </Stack>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="left"
                spacing={1}
              >
                <Typography
                  variant="subtitle2"
                  sx={{
                    width: '25%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'pre'
                  }}
                >
                  Data urodzenia
                </Typography>
                <SmallFormDateField
                  name="birth_date"
                  disabled
                  value={formik.values.birth_date}
                  onChange={val => formik.setFieldValue('birth_date', formatDate(val))}
                  sx={{ width: '75%' }}
                />
              </Stack>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="left"
                spacing={1}
              >
                <Typography
                  variant="subtitle2"
                  sx={{
                    width: '25%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'pre'
                  }}
                >
                  Email
                </Typography>
                <SmallFormTextField
                  name="correspondence_email"
                  disabled
                  placeholder="Email"
                  value={formik.values.correspondence_email}
                  onChange={formik.handleChange}
                  helperText={formik.errors.correspondence_email}
                  error={
                    formik.errors.correspondence_email &&
                    formik.touched.correspondence_email
                  }
                  sx={{ width: '75%' }}
                />
              </Stack>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="left"
                spacing={1}
              >
                <Typography
                  variant="subtitle2"
                  sx={{
                    width: '25%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'pre'
                  }}
                >
                  Telefon
                </Typography>
                <SmallFormTextField
                  name="phone"
                  disabled
                  placeholder="Telefon"
                  value={formik.values.phone}
                  onChange={formik.handleChange}
                  helperText={formik.errors.phone}
                  error={formik.errors.phone && formik.touched.phone}
                  sx={{ width: '75%' }}
                />
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      </Stack>
      <Stack sx={{ mt: 2 }}>
        <Card>
          <CardContent>
            <Stack spacing={2}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="left"
                spacing={1}
              >
                <Typography
                  variant="subtitle2"
                  sx={{
                    width: '25%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'pre'
                  }}
                >
                  Funkcja
                </Typography>
                <SmallFormTextField
                  disabled
                  name="function_type"
                  select
                  placeholder="Funkcja"
                  value={formik.values.function_type}
                  onChange={formik.handleChange}
                  options={choices.function_type}
                  sx={{ width: '75%' }}
                />
              </Stack>

              <Stack
                direction="row"
                alignItems="flex-start"
                justifyContent="left"
                spacing={1}
              >
                <Tooltip title="Uprawnienia pedagogiczne" enterTouchDelay={0} leaveTouchDelay={3000}>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      width: '25%',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'pre'
                    }}
                  >
                  Uprawnienia pedagogiczne
                  </Typography>
                </Tooltip>
                <SmallFormTextField
                  name="pedagogical_qualifications"
                  disabled
                  select
                  multiple
                  placeholder="Uprawnienia pedagogiczne"
                  value={formik.values.pedagogical_qualifications}
                  onChange={formik.handleChange}
                  options={choices.pedagogical_qualifications}
                  sx={{ width: '75%' }}
                  renderValue={selected => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {selected.map(value => (
                        <Chip key={value} label={value} />
                      ))}
                    </Box>
                  )}
                />
              </Stack>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="left"
                spacing={1}
              >
                <Tooltip title="Inne uprawnienia pedagogiczne" enterTouchDelay={0} leaveTouchDelay={3000}>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      width: '25%',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'pre'
                    }}
                  >
                  Inne uprawnienia pedagogiczne
                  </Typography>
                </Tooltip>
                <SmallFormTextField
                  name="other_pedagogical_qualifications"
                  disabled
                  placeholder="Inne uprawnienia pedagogiczne"
                  value={formik.values.other_pedagogical_qualifications}
                  onChange={formik.handleChange}
                  sx={{ width: '75%' }}
                />
              </Stack>
              <Stack
                direction="row"
                alignItems="flex-start"
                justifyContent="left"
                spacing={1}
              >
                <Tooltip title="Pozostałe uprawnienia" enterTouchDelay={0} leaveTouchDelay={3000}>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      width: '25%',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'pre'
                    }}
                  >
                  Pozostałe uprawnienia
                  </Typography>
                </Tooltip>
                <SmallFormTextField
                  name="additional_qualifications"
                  disabled
                  select
                  multiple
                  placeholder="Pozostałe uprawnienia"
                  value={formik.values.additional_qualifications}
                  onChange={formik.handleChange}
                  options={choices.additional_qualifications}
                  sx={{ width: '75%' }}
                  renderValue={selected => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {selected.map(value => (
                        <Chip key={value} label={value} />
                      ))}
                    </Box>
                  )}
                />
              </Stack>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="left"
                spacing={1}
              >
                <Tooltip title="Inne uprawnienia" enterTouchDelay={0} leaveTouchDelay={3000}>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      width: '25%',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'pre'
                    }}
                  >
                  Inne uprawnienia
                  </Typography>
                </Tooltip>
                <SmallFormTextField
                  name="other_additional_qualifications"
                  disabled
                  placeholder="Inne uprawnienia"
                  value={formik.values.other_additional_qualifications}
                  onChange={formik.handleChange}
                  sx={{ width: '75%' }}
                />
              </Stack>
              {/* 7 - instruktor 12 - pomocnik instruktora */}
              {formik.values.function_type == 7 ||
              formik.values.function_type == 12 ? (
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="left"
                    spacing={1}
                  >
                    <Typography
                      variant="subtitle2"
                      sx={{
                        width: '25%',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'pre'
                      }}
                    >
                      Sport instruktora
                    </Typography>
                    <SmallFormTextField
                      name="instructor_sport_type"
                      disabled
                      placeholder="Sport instruktora"
                      value={formik.values.instructor_sport_type}
                      onChange={formik.handleChange}
                      sx={{ width: '75%' }}
                    />
                  </Stack>
                ) : null}
              {/* 7 - instruktor 12 - pomocnik instruktora */}
              {formik.values.function_type == 7 ||
                formik.values.function_type == 12 ? (
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="left"
                    spacing={1}
                  >
                    <Typography
                      variant="subtitle2"
                      sx={{
                        width: '25%',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'pre'
                      }}
                    >
                      Specjalizacja instruktora
                    </Typography>
                    <SmallFormTextField
                      name="instructor_specialization"
                      disabled
                      placeholder="Specjalizacja na umowie"
                      value={formik.values.instructor_specialization}
                      onChange={formik.handleChange}
                      sx={{ width: '75%' }}
                    />
                  </Stack>
                ) : null}
              <Stack
                direction="row"
                alignItems="flex-start"
                justifyContent="left"
                spacing={1}
              >
                <Typography
                  variant="subtitle2"
                  sx={{
                    width: '25%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'pre'
                  }}
                >
                  Zakres umiejętności
                </Typography>
                <SmallFormTextField
                  name="range_of_skills"
                  select
                  multiple
                  placeholder="Zakres umiejętności"
                  value={formik.values.range_of_skills}
                  onChange={formik.handleChange}
                  options={choices.range_of_skills}
                  sx={{ width: '75%' }}
                  renderValue={selected => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {selected.map(value => (
                        <Chip key={value} label={value} />
                      ))}
                    </Box>
                  )}
                />
              </Stack>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="left"
                spacing={1}
              >
                <Typography
                  variant="subtitle2"
                  sx={{
                    width: '25%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'pre'
                  }}
                >
                  Inne umiejętności
                </Typography>
                <SmallFormTextField
                  name="other_skills"
                  disabled
                  placeholder="Inne umiejętności"
                  value={formik.values.other_skills}
                  onChange={formik.handleChange}
                  sx={{ width: '75%' }}
                />
              </Stack>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="left"
                spacing={1}
              >
                <Typography
                  variant="subtitle2"
                  sx={{
                    width: '25%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'pre'
                  }}
                >
                  Rozmiar odzieży firmowej
                </Typography>
                <SmallFormTextField
                  name="company_clothing_size"
                  disabled
                  select
                  placeholder="Rozmiar odzieży firmowej"
                  value={formik.values.company_clothing_size}
                  onChange={formik.handleChange}
                  options={choices.company_clothing_size}
                  sx={{ width: '75%' }}
                />
              </Stack>


            </Stack>
          </CardContent>
        </Card>
      </Stack>
      <ImageModal
        open={openImage}
        handleClose={() => setOpenImage(false)}
        src={preview}
      />
    </Stack>
  );
}
